import { useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, EffectFade } from 'swiper';
import { TimelineMax, TweenMax } from 'gsap';
import Oven from '@elem/SVGIcon/VanlifeRoadtrips/Oven';
import Dryer from '@elem/SVGIcon/Homebattery/Dryer';
import { useAnimate } from '../utils';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFLight from '@/components/UI/svg/LandingPage/EFLight';
import EFWifiRouter from '@/components/UI/svg/LandingPage/EFWifiRouter';
import EFRefrigerator from '@/components/UI/svg/LandingPage/EFRefrigerator';
import EFElectricHeater from '@/components/UI/svg/LandingPage/EFElectricHeater';
import EFMicroware from '@/components/UI/svg/LandingPage/EFMicroware';
import EFElectricKettle from '@/components/UI/svg/LandingPage/EFElectricKettle';
import EFAirConditioner from '@/components/UI/svg/LandingPage/EFAirConditioner';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/img/landingPage/');

export default function F0(): JSX.Element {
    const { useLang, Link, gtm, useRouter } = useGlobal();
    const { t } = useLang('landingPage');
    const { locale } = useRouter();

    const itemList = [
        {
            name: t('secF_Light'),
            times: `6.7 days`,
            icon: <EFLight />,
        },
        {
            name: t('secF_WiFiRouter'),
            times: `7.5 days`,
            icon: <EFWifiRouter />,
        },
        {
            name: '50" TV',
            times: `45 hr`,
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20.901 5.23242C21.7004 5.23242 22.3484 5.88038 22.3484 6.67975V17.3012C22.3484 18.0182 21.7672 18.5994 21.0501 18.5994L15.0169 18.5989V20.2024L17.2358 20.2027C17.4567 20.2027 17.6358 20.3818 17.6358 20.6027C17.6358 20.8016 17.4907 20.9665 17.3006 20.9975L17.2358 21.0027H6.76311C6.5422 21.0027 6.36311 20.8237 6.36311 20.6027C6.36311 20.4039 6.50817 20.239 6.69823 20.208L6.76311 20.2027L8.98089 20.2024V18.5989L3.09771 18.5994C2.33641 18.5994 1.71244 18.0117 1.65474 17.2652L1.65039 17.1521V6.67975C1.65039 5.88038 2.29835 5.23242 3.09771 5.23242H20.901ZM14.2171 18.599H9.78087V20.2025H14.2171V18.599ZM20.901 6.03242H3.09771C2.74018 6.03242 2.45039 6.32221 2.45039 6.67975V17.1521C2.45039 17.5096 2.74018 17.7994 3.09771 17.7994H21.0501C21.3253 17.7994 21.5484 17.5764 21.5484 17.3012V6.67975C21.5484 6.32221 21.2586 6.03242 20.901 6.03242ZM19.7005 7.2302C19.9214 7.2302 20.1005 7.40929 20.1005 7.6302V16.2016C20.1005 16.4225 19.9214 16.6016 19.7005 16.6016H4.27193C4.05102 16.6016 3.87193 16.4225 3.87193 16.2016V7.6302C3.87193 7.40929 4.05102 7.2302 4.27193 7.2302H19.7005ZM19.2999 8.03002H4.67187V15.8015H19.2999V8.03002Z"
                        fill="#fff"
                    />
                </svg>
            ),
        },
        {
            name: t('secF_Refrigerator'),
            times: `1.7-3.3 days`,
            icon: <EFRefrigerator />,
        },
        {
            name: t('secF_ElectricKettle'),
            times: `3.7 hr`,
            icon: <EFElectricKettle />,
        },
        {
            name: t('secF_ElectricHeater'),
            times: `2.5 hr`,
            icon: <EFElectricHeater />,
        },
        {
            name: 'Electric Oven',
            times: `3.3 hr`,
            icon: <Oven className="w" />,
        },
        {
            name: 'Microwave',
            times: `4.2 hr`,
            icon: <EFMicroware />,
        },
        {
            name: t('secF_AirConditioner'),
            times: `3-6 hr`,
            icon: <EFAirConditioner />,
        },
        {
            name: 'Clothes Dryer',
            times: `1.2 hr`,
            icon: <Dryer className="w" />,
        },
    ];

    useEffect(() => {
        const { createScene, destroy, layoutH } = useAnimate();

        createScene({
            triggerElement: '.landing_page_F0',
            triggerHook: 1,
            offset: layoutH + 250,
        })
            .setClassToggle('.landing_page_F0', 'show')
            .addTo(aniController);

        createScene({
            triggerElement: '.landing_page_F0',
            triggerHook: 1,
            offset: 200,
            duration: (layoutH * 2) / 3,
        })
            .setTween(
                new TimelineMax().add(
                    TweenMax.to('.landing_page_F0_wrapper', 1, {
                        opacity: 1,
                    }),
                ),
            )
            .addTo(aniController);

        return () => destroy();
    }, []);

    const handleBuyNow = () => {
        try {
            // GA埋点
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy',
                product_name: t('secF_pro_name'),
                position: `Solution Page_${t('secF_title')}`,
            });
            // fb埋点
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.log(e);
        }
    };

    return (
        <div className={`landing_page_F0 ${css.landing_page_F0}`}>
            <div className="landing_page_F0_wrapper">
                <div className="page_F_left">
                    <div className="page_F_leftBox">
                        <div className="leftContentBox_1">
                            <div className="leftInnerBox">
                                <div className="secF_powerList">{t('secF_powerList')}</div>
                                <div className="leftListBox">
                                    {itemList.map((item: any, index: number) => (
                                        <div key={index} className="leftListItem">
                                            <div className="itemImg">{item.icon}</div>
                                            <div>
                                                <div className="itemName">{item.name}</div>
                                                <div className="itemTimes">{item.times}</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="leftContentBox_2">
                            <div>
                                <div className="secF_title">{'Starter Kit'}</div>
                                <div className="secF_pro_name">{'EcoFlow DELTA Pro Ultra + Transfer Switch (30A）'}</div>
                                <div className="secF_pro_paramBox">
                                    <div className="secF_pro_param">{'- Clean and quiet power alternative'}</div>
                                    <div className="secF_pro_param">{'- Completely pre-wired for easy installation'}</div>
                                </div>
                                <div className="secF_pro_desc">{'Plug-and-play home backup solution.'}</div>
                                <Link href={'https://ca.ecoflow.com/pages/delta-pro-ultra'} target="blank">
                                    <div className="secFButton btnHover" onClick={handleBuyNow}>
                                        {t('secF_buyNow')}
                                    </div>
                                </Link>
                                <div className="secF_tip">{t('secF_tip')}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="page_F_right">
                    <Swiper
                        pagination={{ clickable: true }}
                        modules={[Pagination, Autoplay, EffectFade]}
                        effect="fade"
                        className="swiperBox"
                        autoplay={{
                            delay: 5000,
                        }}
                        loop
                    >
                        <SwiperSlide>
                            <EFPic className="pageFImg" name={['DPU+TS(30A)_scene.jpg', 'DPU+TS(30A)_scene.jpg']} />
                        </SwiperSlide>
                        <SwiperSlide>
                            <EFPic className="pageFImg scale" name={['DPU+TS(30A).png', 'DPU+TS(30A).png']} />
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>
        </div>
    );
}
